<template>
    <div>
        <div :class="theme.checkbox">
            <div>
                <div @click="handleClick" :class="theme.checkboxOverlay" v-ripple="rippleColor"></div>
                <checkbox-raw :value="value" :data="data" :theme="theme" />
            </div>
            <div :class="theme.label"><slot name="label">{{ label }}</slot></div>
        </div>
        <div v-if="this.error" :class="[theme.caption, theme.hasError]">
            <slot name="error" :error="this.error">
                {{this.error}}
            </slot>
        </div>
        <div v-if="this.caption" :class="theme.caption">
            <slot name="caption" :caption="this.caption">
                {{this.caption}}
            </slot>
        </div>
    </div>
</template>
<script>
    import { Ripple } from '../../directives';
    import CheckboxRaw from './CheckboxRaw';
    import theme from './checkbox.scss';

    export default {
        name: 'checkbox',
        props: {
            label: String,
            error: String,
            caption: String,
            value: {
                type: Array,
                default() {
                    return [];
                }
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            data: [
                String,
                Number,
                Boolean,
                Object // { id: Number, ...}
            ],
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            rippleColor: {
                type: String,
                default: 'rgba(3, 169, 244, .15)',
            }
        },
        components: { CheckboxRaw },
        directives: { Ripple },
        computed: {
            isChecked() {
                return this.value.find((item) => {
                    if(typeof(this.data) !== 'object'){
                        return item === this.data
                    }
                    else {
                        return item.id === this.data.id
                    }

                }) !== undefined;
            },
        },
        methods: {
            handleClick() {
                if (this.readonly) {
                    return;
                }

                this.$emit('input', this.isChecked
                    ? this.value.filter((item) => {
                        if(typeof(this.data) !== 'object'){
                            return item !== this.data
                        }
                        else {
                            return item.id !== this.data.id
                        }
                    })
                    : this.value.concat([this.data])
                );
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Checkbox.vue?cdd7ced6